import axios from 'axios';
let API_URL;
if (process.env.REACT_APP_DEV==='dev') {
  API_URL = process.env.REACT_APP_API_URL;
} else {
  API_URL = process.env.REACT_APP_API_BACKEND_URL;
}

/**
 * Tüm markaları getirir
 * @returns {Promise<Array>} Markalar dizisi
 */
export const getBrands = async () => {
  try {
    const response = await axios.get(API_URL+'/brands');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching brands:', error);
    throw error;
  }
};

/**
 * Belirli bir markayı getirir
 * @param {string} id - Marka ID
 * @returns {Promise<Object>} Marka detayları
 */
export const getBrandById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/brands/${id}`);
    return response.data.data;
  } catch (error) {
    console.error(`Error fetching brand ${id}:`, error);
    throw error;
  }
};

/**
 * Yeni marka oluşturur (sadece admin)
 * @param {Object} brandData - Marka verileri
 * @returns {Promise<Object>} Oluşturulan marka
 */
export const createBrand = async (brandData) => {
  try {
    const response = await axios.post(API_URL+'/brands', brandData);
    return response.data.data;
  } catch (error) {
    console.error('Error creating brand:', error);
    throw error;
  }
};

/**
 * Marka bilgilerini günceller (sadece admin)
 * @param {string} id - Marka ID
 * @param {Object} brandData - Güncellenecek marka verileri
 * @returns {Promise<Object>} Güncellenmiş marka
 */
export const updateBrand = async (id, brandData) => {
  try {
    const response = await axios.put(`${API_URL}/brands/${id}`, brandData);
    return response.data.data;
  } catch (error) {
    console.error(`Error updating brand ${id}:`, error);
    throw error;
  }
};

/**
 * Markayı siler (sadece admin)
 * @param {string} id - Marka ID
 * @returns {Promise<boolean>} İşlem başarılı mı?
 */
export const deleteBrand = async (id) => {
  try {
    await axios.delete(`${API_URL}/brands/${id}`);
    return true;
  } catch (error) {
    console.error(`Error deleting brand ${id}:`, error);
    throw error;
  }
}; 